import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=586e50a2&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports